/* eslint-disable no-console */
import { useEffect, useRef } from "react";

import useI18N from "../../../hooks/useI18N";

export default function TapCard({
  onToken,
  session,
  onReady,
  onError,
  amount = 0,
  currency = "BHD",
}) {
  const { dir } = useI18N();
  const unmountRef = useRef(null);

  const { email, phone_country_code, phone_number } = session;

  useEffect(() => {
    const renderCard = () => {
      const { renderTapCard, Currencies, Theme, Direction, Edges, Locale } =
        window.CardSDK;

      const { unmount } = renderTapCard("card-sdk-id", {
        publicKey: process.env.REACT_APP_TAP_PUBLIC_KEY,
        merchant: { id: process.env.REACT_APP_TAP_MERCHANT_ID },
        transaction: {
          amount: amount,
          currency: Currencies[currency],
        },
        customer: {
          nameOnCard: "",
          editable: true,
          contact: {
            email: email,
            phone: { countryCode: phone_country_code, number: phone_number },
          },
        },

        acceptance: {
          supportedBrands: [],
          supportedCards: "ALL",
        },
        fields: {
          cardHolder: true,
        },

        addons: {
          displayPaymentBrands: true,
          loader: true,
          saveCard: false,
        },

        interface: {
          locale: dir === "rtl" ? Locale.AR : Locale.EN,
          edges: Edges.CURVED,
          theme: Theme.LIGHT,
          direction: dir === "rtl" ? Direction.RTL : Direction.LTR,
        },

        onReady: () => {
          console.log("Tap Card SDK ready");
          onReady?.();
        },

        onSuccess: (data) => {
          console.log("Card token generated successfully:", data.id);
          onToken?.(data.id);
        },

        onError: (data) => {
          console.error("Tap SDK Error:", data);
          onError?.();
        },

        onFocus: () => console.log("Card field focused"),
        onBinIdentification: (data) => console.log("Card BIN info:", data),
        onValidInput: (data) => console.log("Input validity changed:", data),
      });

      unmountRef.current = unmount;
    };

    if (window.CardSDK) {
      renderCard();
    } else {
      const script = document.createElement("script");
      script.src = process.env.REACT_APP_TAP_SDK_URL;
      script.async = true;
      script.onload = renderCard;
      document.head.appendChild(script);
    }

    return () => {
      if (unmountRef.current) {
        unmountRef.current();
      }
    };
  }, [onToken, dir, amount, currency]);

  return <div id="card-sdk-id" style={{ minHeight: 200 }} />;
}
